export const KEY_SESSION = 'SESSION';
export const ACTIVE_QUOTE = 'ACTIVE_QUOTE';

// Highlevel datamodel for APP state
// {
//     auth:{
//     }
//     quote:{
//     }
//     credit:{
//     }
// }

class SessionManager {
    constructor() {
        this.defaultSession = {
            auth: null,
            quote: null,
            credit: null,
            profile: null
        };

        this.setSession(this.getSession());
    }
    setSession(session) {
        localStorage.setItem(KEY_SESSION, JSON.stringify(session));
    }
    getSession() {
        return (
            JSON.parse(localStorage.getItem(KEY_SESSION)) || this.defaultSession
        );
    }
    unsetSession() {
        localStorage.removeItem(KEY_SESSION);
    }
    getAppState() {
        return this.getSession();
    }
    setState(key, value) {
        const currentState = this.getSession();
        currentState[key] = value;
        this.setSession(currentState);
    }
    getAccessToken = () => {
        if (this.getAppState().auth) return this.getAppState().auth.authToken;
        return '';
    };
    getUser = () => {
        if (this.getAppState().auth) return this.getAppState().auth.user;
        return '';
    };
    // getUser() {
    //     return this.getSession().user;
    // }
    // setQuoteState(quote) {
    //     sessionStorage.setItem(ACTIVE_QUOTE, JSON.stringify(quote));
    // }
    // getQuoteState() {
    //     return JSON.parse(sessionStorage.getItem(ACTIVE_QUOTE));
    // }
    // unsetQuote() {
    //     sessionStorage.removeItem(ACTIVE_QUOTE);
    // }
}

const sessionManager = new SessionManager();
export default sessionManager;



// WEBPACK FOOTER //
// ./src/utils/managers/sessionManager.js